import React, { useState } from "react";
import img1 from "../../assets/images/khojgraphics/Moving_graphic_3.gif";
import img2 from "../../assets/images/khojgraphics/About_Us_Graphic_2.gif";

function Review(props) {
	const [viewPortEntered, setViewPortEntered] = useState(false);

	const onVWEnter = () => {
		setViewPortEntered(true);
	};

	return (
		<section className="inner-review-section inner-review-section-mobile">
			<div className="container">
				<div className="row">
					<div className="col-lg-6 col-md-12 about-image-container">
						<div className="wd-review-job thumb2 widget-counter stc me-4 mt-5 about-mobile">
							<div className="career-about-image">
								<img src={img1} alt="images" width={"70%"} />
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 wow fadeInRight">
						<div className="wd-review-job contentbox1 page-text">
							<h3><span className="khoj-text-color">KHOJ</span> : Your Career. Your Calling</h3>

							{/* at mobile view only */}
							<div className="col-lg-6 col-md-12 about-image-container about-image-containe-formob">
								<div className="wd-review-job thumb2 widget-counter stc me-4 about-mobile">
									<div className="career-about-image career-about-image-mob">
										<img src={img1} alt="images" width={"70%"} />
									</div>
								</div>
							</div>



							<p className="mb-2">
								Every year, over 13 million individuals enter India’s workforce with dreams in their eyes and academic credentials, yet the critical gap between education and employment persists. In 2024, only 51.25% of graduates were considered employable, an improvement from 34% a decade ago. Despite this progress, the challenges are stark — unemployment among graduates has climbed dramatically, from 35.2% in 2000 to 65.7% in 2022, according to the Ministry of Statistics and Programme Implementation (MOSPI), Government of India.
							</p>
							<p className="mb-2">
								Behind these statistics lie untold stories—graduates caught in the paradox of being highly qualified yet struggling to secure meaningful employment, professionals overwhelmed by the multitude of career options, and individuals whose aspirations fall short because they lack the guidance and direction to realize their full potential.

							</p>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 wow fadeInRight fadeRightLeft-tab-img-para">
						<div className="wd-review-job contentbox1 page-text">
							<p>
								At Khoj, we don’t see these statistics as failures; we see them as untapped possibilities. Possibilities to empower, to guide, and to transform the way young people navigate their careers. We’re not just a platform; we’re your career companion. In a world full of choices and uncertainties, we’re here to help you find the path that feels right—one that resonates with who you are and what you aspire to be, not one you settle for.

							</p>
							<p>
								At  Khoj, we believe a career isn’t just about landing a job—it’s your story in the making. It’s about shaping a life that aligns with your passion and values, waking up each day with purpose, inspired by what lies ahead, and knowing that the work you do truly matters to you.
							</p>
							<p>
								Our mission is simple yet powerful: to be the partner of first-choice for youth development in the country, hand-holding. every dreamer, every doer, and every visionary striving to make their mark. At our core, we believe the right path should never be out of reach, and when talent meets its rightful stage, extraordinary things happen.

							</p>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 fadeRightLeft-tab-img-para d-flex justify-content-center">
						<div className="wd-review-job thumb2 widget-counter stc me-4 mt-5 about-mobile">
							<div className="khoj-career-imag khoj-career-image-one">
								<img src={img2} alt="images" className="mt-4" width={"90%"} />
							</div>
						</div>
					</div>

					{/*.................. Mobile  & Tablet ............... */}
					<div className="col-lg-6 col-md-12 fadeRightLeft-mob-img-para">
						<div className="wd-review-job thumb2 widget-counter stc me-4 mt-5 about-mobile">
							<div className="khoj-career-image career-about-image-mob career-about-image-mob-two">
								<img src={img2} alt="images" className="mt-4" width={"100%"} />
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 wow fadeInRight fadeRightLeft-mob-img-para">
						<div className="wd-review-job contentbox1 page-text">
							<p>
								At <span className="f-600">KHOJ</span>, we don’t see these statistics as failures; we see them as untapped possibilities. Possibilities to empower, to guide, and to transform the way young people navigate their careers. We’re not just a platform; we’re your career companion. In a world full of choices and uncertainties, we’re here to help you find the path that feels right—one that resonates with who you are and what you aspire to be, not one you settle for.

							</p>
							<p>
								At <span className="f-600">KHOJ</span>, we believe a career isn’t just about landing a job—it’s YOUR story in the making. It’s about shaping a life that aligns with your passion and values, waking up each day with purpose, inspired by what lies ahead, and knowing that the work you do truly matters to you.
							</p>
							<p>
								Our mission is simple yet powerful: to be the partner of first-choice for youth development in the country, hand-holding. every dreamer, every doer, and every visionary striving to make their mark. At our core, we believe the right path should never be out of reach, and when talent meets its rightful stage, extraordinary things happen.

							</p>
						</div>
					</div>

				</div>
			</div>
		</section>
	);
}

export default Review;
